
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "contexts/AuthContext";
import { Floor } from "utils/floor";

type UseDeleteFloorMutationVariablesPayload = {
  id: string;
}

const useDeleteFloorMutation = (projectId: string) => {
  const { authApi } = useAuth();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: UseDeleteFloorMutationVariablesPayload) => {
      // if (!projectId) return;
      const { data } = await authApi.delete<Floor>(`/floor/${payload.id}`);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["floors", projectId],
      });
    },
  });
};

export default useDeleteFloorMutation